// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1aWSK","footer":"ModalFilter_footer__gVeK-"};